<script>
import {Link} from "@inertiajs/vue3";
import IconWhatsApp from "@js/components/Icons/IconWhatsApp.vue";
import IconTelegram from "@js/components/Icons/IconTelegram.vue";
import IconEnvelope from "@js/components/Icons/IconEnvelope.vue";
import {copyText} from "@js/helpers.ts";
import {useThemeStore} from "@js/store/ThemeStore.js";
import OnlyMobile from "@js/components/DynamicComponents/OnlyMobile.vue";
import OnlyDesktop from "@js/components/DynamicComponents/OnlyDesktop.vue";
import SalesDepartmentPhone from "@js/components/Sections/Links/SalesDepartmentPhone.vue";
import IconPaymentVisa from "@js/components/Icons/IconPaymentVisa.vue";
import IconPaymentMir from "@js/components/Icons/IconPaymentMir.vue";
import IconPaymentMasterCard from "@js/components/Icons/IconPaymentMasterCard.vue";
import IconPaymentMaestro from "@js/components/Icons/IconPaymentMaestro.vue";
import IconPaymentSbp from "@js/components/Icons/IconPaymentSbp.vue";
import IconLogo from "@js/components/Icons/IconLogo.vue";
import IconExcelColored from "@js/components/Icons/IconExcelColored.vue";
import {contacts, requisites} from "@js/company_details.ts";

export default {
    name: "Footer",

    components: {
        IconExcelColored,
        IconLogo,
        IconPaymentSbp,
        IconPaymentMaestro,
        IconPaymentMasterCard,
        IconPaymentMir,
        IconPaymentVisa,
        SalesDepartmentPhone,
        OnlyDesktop,
        OnlyMobile,
        IconEnvelope,
        IconTelegram,
        IconWhatsApp,
        Link,
    },

    data() {
        return {
            currentYear: new Date().getFullYear(),
        };
    },

    setup() {
        return {
            contacts,
            requisites,
        };
    },

    methods: {
        copyText(text, message = "Скопировано") {
            copyText(text);

            const themeStore = useThemeStore();
            themeStore.addToast(message, "success");
        },
    },
};
</script>

<template>
    <footer class="mt-16 rounded-t-[32px] bg-grayBg text-black md:rounded-t-[64px] max-md:pb-20">
        <div class="border-b border-b-gray-200 pb-5 pt-10">
            <div class="container mx-auto my-5">
                <div class="mb-10 flex justify-between gap-5">
                    <div>
                        <Link :href="route('home')" aria-label="На главную">
                            <IconLogo class="h-auto w-[150px] md:w-[240px]"/>
                        </Link>
                    </div>

                    <div class="text-right">
                        <div class="mb-2 md:mb-4">
                            <SalesDepartmentPhone
                                class="text-nowrap border-b border-transparent text-xl font-bold transition md:text-2xl md:hover:border-black"
                            />
                        </div>

                        <ul class="mt-0 flex flex-row justify-end space-x-2 text-sm font-medium">
                            <li class="h-10 w-10 rounded-lg bg-whatsapp transition-all duration-300 md:hover:rounded-[50px]">
                                <a
                                    :href="contacts.whatsapp"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    class="flex h-full w-full items-center justify-center"
                                    aria-label="WhatsApp"
                                    title="WhatsApp"
                                >
                                    <IconWhatsApp class="h-6 w-6 text-white"/>
                                </a>
                            </li>

                            <li class="h-10 w-10 rounded-lg bg-[#0088CC] transition-all duration-300 md:hover:rounded-[50px]">
                                <a
                                    :href="contacts.telegram"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    class="flex h-full w-full items-center justify-center"
                                    aria-label="Telegram"
                                    title="Telegram"
                                >
                                    <IconTelegram class="-ms-0.5 h-5 w-5 text-white"/>
                                </a>
                            </li>

                            <li class="h-10 w-10 rounded-lg bg-amber-500 transition-all duration-300 md:hover:rounded-[50px]">
                                <OnlyMobile class="h-full w-full">
                                    <a
                                        :href="'mailto:' + contacts.info_mail"
                                        title="Почта"
                                        aria-label="Почта"
                                        class="flex h-full w-full items-center justify-center"
                                    >
                                        <IconEnvelope class="h-5 w-5 text-white"/>
                                    </a>
                                </OnlyMobile>

                                <OnlyDesktop
                                    class="flex h-full w-full cursor-pointer items-center justify-center"
                                    title="Скопировать почту"
                                    aria-label="Скопировать почту"
                                    @click.prevent="copyText(contacts.info_mail, 'Почта скопирована')"
                                >
                                    <IconEnvelope class="h-5 w-5 text-white"/>
                                </OnlyDesktop>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="grid grid-cols-12 gap-5">
                    <div class="col-span-12 md:col-span-8">
                        <div class="grid grid-cols-2 gap-8 text-sm md:grid-cols-4 md:gap-10">
                            <div>
                                <div class="mb-5 font-bold">
                                    Каталог
                                </div>

                                <div class="grid gap-2">
                                    <Link
                                        :href="route('catalog', {type_slug: 'pilomaterialy'})"
                                        class="text-sm font-medium text-gray-900 transition md:hover:text-navHoverColor"
                                    >
                                        Пиломатериалы
                                    </Link>

                                    <Link
                                        :href="route('catalog', {type_slug: 'trotuarnaya_plitka'})"
                                        class="text-sm font-medium text-gray-900 transition md:hover:text-navHoverColor"
                                    >
                                        Тротуарная плитка
                                    </Link>

                                    <Link
                                        :href="route('catalog', {type_slug: 'zhbi'})"
                                        class="text-sm font-medium text-gray-900 transition md:hover:text-navHoverColor"
                                    >
                                        Железобетонные изделия
                                    </Link>

                                    <Link
                                        :href="route('catalog', {type_slug: 'beton'})"
                                        class="text-sm font-medium text-gray-900 transition md:hover:text-navHoverColor"
                                    >
                                        Бетонные смеси
                                    </Link>

                                    <Link
                                        :href="route('comingSoon')"
                                        class="text-sm font-medium text-gray-900 transition md:hover:text-navHoverColor"
                                    >
                                        Нерудные материалы
                                    </Link>

                                    <Link
                                        :href="route('comingSoon')"
                                        class="text-sm font-medium text-gray-900 transition md:hover:text-navHoverColor"
                                    >
                                        Конструкции
                                    </Link>
                                </div>
                            </div>

                            <div>
                                <div class="mb-5 font-bold">
                                    Покупателям
                                </div>

                                <div class="grid gap-2">
                                    <Link
                                        :href="route('contacts')"
                                        class="text-sm font-medium text-gray-900 transition md:hover:text-navHoverColor"
                                    >
                                        Контакты
                                    </Link>

                                    <Link
                                        :href="route('aboutCompany')"
                                        class="text-sm font-medium text-gray-900 transition md:hover:text-navHoverColor"
                                    >
                                        О компании
                                    </Link>

                                    <Link
                                        :href="route('deliveryAndShipping')"
                                        class="text-sm font-medium text-gray-900 transition md:hover:text-navHoverColor"
                                    >
                                        Доставка
                                    </Link>

                                    <Link
                                        :href="route('aboutPayment')"
                                        class="text-sm font-medium text-gray-900 transition md:hover:text-navHoverColor"
                                    >
                                        Способы оплаты
                                    </Link>

                                    <Link
                                        :href="route('returnGuarantee')"
                                        class="text-sm font-medium text-gray-900 transition md:hover:text-navHoverColor"
                                    >
                                        Обмен и возврат
                                    </Link>
                                </div>
                            </div>

                            <div>
                                <div class="mb-5 font-bold">
                                    Сервисы
                                </div>

                                <div class="grid gap-2">
                                    <Link
                                        :href="route('priceList')"
                                        class="text-sm font-medium text-gray-900 transition md:hover:text-navHoverColor"
                                    >
                                        <span class="inline-flex items-center gap-1">
                                            <IconExcelColored
                                                class="h-4 w-4"
                                                third_color="#45ba4b"
                                                fourth_color="#fff"
                                            />
                                            Прайс-лист
                                        </span>
                                    </Link>

                                    <Link
                                        :href="route('cart')"
                                        class="text-sm font-medium text-gray-900 transition md:hover:text-navHoverColor"
                                    >
                                        Смета
                                    </Link>

                                    <Link
                                        :href="route('likedProducts')"
                                        class="text-sm font-medium text-gray-900 transition md:hover:text-navHoverColor"
                                    >
                                        Избранное
                                    </Link>

                                    <Link
                                        :href="route('compareProducts')"
                                        class="text-sm font-medium text-gray-900 transition md:hover:text-navHoverColor"
                                    >
                                        Сравнение
                                    </Link>

                                    <Link
                                        :href="route('comingSoon')"
                                        class="text-sm font-medium text-gray-900 transition md:hover:text-navHoverColor"
                                    >
                                        Калькулятор материалов
                                    </Link>
                                </div>
                            </div>

                            <div>
                                <div class="mb-5 font-bold">
                                    Документы
                                </div>

                                <div class="grid gap-2">
                                    <Link
                                        :href="route('privacyPolicy')"
                                        class="text-sm font-medium text-gray-900 transition md:hover:text-navHoverColor"
                                    >
                                        Политика конфиденциальности
                                    </Link>

                                    <Link
                                        :href="route('publicOffer')"
                                        class="text-sm font-medium text-gray-900 transition md:hover:text-navHoverColor"
                                    >
                                        Публичная оферта
                                    </Link>

                                    <Link
                                        :href="route('returnGuarantee')"
                                        class="text-sm font-medium text-gray-900 transition md:hover:text-navHoverColor"
                                    >
                                        Возврат товара
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-span-12 md:col-span-1"></div>

                    <div class="col-span-12 md:col-span-3">
                        <div class="flex flex-col gap-5">
                            <div class="flex items-center justify-between rounded-xl border-2 border-baseColor p-5 text-xs font-medium">
                                <IconPaymentVisa class="h-[30px] w-auto"/>
                                <IconPaymentMir class="h-[30px] w-auto"/>
                                <IconPaymentMasterCard class="h-[30px] w-auto"/>
                                <IconPaymentMaestro class="h-[30px] w-auto"/>
                                <IconPaymentSbp class="h-[30px] w-auto"/>
                            </div>

                            <div class="rounded-xl border-2 border-baseColor p-5 text-xs font-medium text-gray-700">
                                Указанные на сайте цены не являются публичной офертой
                                (ст. 435 и ст. 437 ГК РФ).
                                <br><br>
                                Цены и наличие товара просьба уточнять по телефону в офисе продаж.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="py-2">
            <div class="container mx-auto">
                <div class="flex flex-col items-center justify-between space-y-3 text-center md:flex-row md:space-y-0 md:text-left">
                    <div class="order-1 text-xs font-bold md:order-1">
                        Copyright © {{ currentYear }} ООО «ФУЛЛ СТРОЙ». Все права защищены.
                    </div>

                    <a
                        href="https://x-devs.ru/"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Разработано в X-Devs"
                        class="order-3 text-xs font-bold transition md:order-2 md:hover:text-navHoverColor"
                    >
                        Разработано в X-Devs
                    </a>

                    <div class="order-2 text-xs font-bold md:order-3">
                        ИНН: {{ requisites.inn }} | КПП: {{ requisites.kpp }} | ОГРН: {{ requisites.ogrn }}
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<style scoped lang="scss">

</style>
